import React, { Component } from 'react';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

import ContentContainer from '../../components/ContentContainer';
import { Theme } from '../../config/theme';
import FacebookChat from '../../components/FacebookChat';

class SettingsHelp extends Component {
  render() {
    return (
      <ContentContainer>
        <div className={css(styles.container)}>
          <div>
            <h2 className={css(styles.h2)}>Member Support</h2>
            <ul className={css(styles.list)}>
              <li className={css(styles.listItem)}>
                <strong className={css(styles.strong)}>Phone:</strong>
                <a href="tel:0800364747">0800 DOG SHR (364 747)</a>
              </li>
              <li className={css(styles.listItem)}>
                <strong className={css(styles.strong)}>Hours:</strong> 10:00am - 4:00pm, Mon - Fri
              </li>
              <li className={css(styles.listItem)}>
                <strong className={css(styles.strong)}>Email: </strong>
                <a href="mailto:support@thedogsharecollective.com">support@thedogsharecollective
                  .com</a>
              </li>
              <li className={css(styles.listItem)}>
                <strong className={css(styles.strong)}>Mail:</strong>
                <address>
                  The Dog Share Collective <br />
                  PO Box 416, Orewa, 0946, <br />
                  Auckland
                </address>
              </li>
            </ul>
          </div>
        </div>
        <FacebookChat />
      </ContentContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: 800,
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',

    [Theme.mobile_query]: {
      width: 'auto',
      flexDirection: 'column',
    },
  },
  h2: {
    fontSize: 20,
    margin: '45px 5px',
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',
    margin: '20px 0',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  list: {
    margin: '0 5px',
  },
  listItem: {
    display: 'flex',
    margin: '0 0 0.7rem 0',
    lineHeight: '1.8',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  strong: {
    fontFamily: Theme.font_family_primary,
    margin: '0 50px 0 0',
    minWidth: 40,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsHelp);



// WEBPACK FOOTER //
// ./src/views/SettingsHelp/index.js